import { drawerAnatomy as parts } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/styled-system';
import { ThemeColorToken } from '../theme-tokens';
const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(parts.keys);
const sizes = {
    xs: definePartsStyle({ dialog: { maxWidth: '320px' } }), // Chakra default
    sm: definePartsStyle({ dialog: { maxWidth: '448px' } }), // Chakra default
    md: definePartsStyle({ dialog: { maxWidth: '560px' } }), // Custom
    lg: definePartsStyle({ dialog: { maxWidth: '672px' } }), // Chakra default
    xl: definePartsStyle({ dialog: { maxWidth: '896px' } }), // Chakra default
};
const baseStyle = definePartsStyle({
    dialog: {
        bg: ThemeColorToken.Surface,
        color: ThemeColorToken.OnSurface,
    },
});
export const drawerConfig = defineMultiStyleConfig({
    baseStyle,
    sizes,
});
//# sourceMappingURL=drawer-theme.js.map